var clientsList = (function () {
  const init = function () {
    $("#clients-datatable").DataTable({
      autoWidth: true,
      stateSave: true,
      responsive: true,
      order: [2, "desc"],
      columnDefs: [
        { orderable: true, targets: 0 },
        {
          orderable: true,
          targets: 1,
        },
        {
          orderable: true,
          targets: 2,
        },
        {
          orderable: true,
          targets: 3,
        },
        {
          orderable: true,
          targets: 4,
        },
        {
          orderable: false,
          targets: 5,
        },
        { orderable: true, targets: 6 },
        { orderable: true, targets: 7 },
        {
          orderable: false,
          targets: 8,
        },
        { orderable: true, targets: 9 },
        { orderable: false, targets: 10 },
      ],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json",
      },
    });

    $("#clients-datatable").on("click", ".mdi-lock", function () {
      const id = $(this).data("client-id");
      sendBlockRequest(id);
    });

    $("#clients-datatable").on("click", ".mdi-lock-open-outline", function () {
      const id = $(this).data("client-id");
      sendUnblockRequest(id);
    });

    $("#clients-datatable").on("click", ".mdi-login", function () {
      const id = $(this).data("client-id");
      sendLoginAsClientAccountOwnerRequest(id);
    });

    $("#clients-datatable").on("click", ".mdi-lock-reset", function () {
      const email = $(this).data("client-email");
      sendChangePasswordInvitation(email);
    });

    $("#clients-datatable").on("click", ".mdi-delete", function () {
      const id = $(this).data("client-id");
      const name = $(this).data("client-name");
      $("#client-name-to-delete").text(name);
      $("#delete-client-button").attr("data-client-id", id);
    });

    $("#delete-client-button").on("click", function () {
      const clientIdToDelete = $(this).data("client-id");
      $.ajax({
        url: `/Clients/Delete/${clientIdToDelete}`,
        method: "DELETE",
        contentType: "application/json",
      }).done(function (data) {
        $("#delete-modal").modal("hide");
        $.showNotification(data.header, data.message, data.succeed);
      });
    });

    $("#export-to-excel").on("click", downloadClickHandler);

    function downloadClickHandler(e) {
      e.preventDefault();

      var $a = $(this);
      var url = $a.attr("href");
      saveReport(url);
    }

    function saveReport(url) {
      requestDocument(url).done(function (blob, textStatus, jqXhr) {
        var fileName = getFileName(jqXhr) || "report.xlsx";
        var contentType = getContentType(jqXhr);
        saveFile(blob, fileName, contentType);
      });
    }

    function saveFile(data, filename, type) {
      var file = new Blob([data], { type: type });
      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      else {
        // Others
        var a = document.createElement("a"),
          url = URL.createObjectURL(file);
        a.setAttribute("target", "_self");
        a.setAttribute("download", filename);
        a.setAttribute("href", url);
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 4e4); // 40s
      }
    }

    function requestDocument(url) {
      return $.ajax({
        method: "GET",
        url: url,
        cache: false,
        xhr: function () {
          var xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          return xhr;
        },
      });
    }

    function getFileName(xhr) {
      var fileName = "";
      var customHeader = xhr.getResponseHeader("Content-Disposition");
      if (customHeader && customHeader.indexOf("attachment") !== -1) {
        var filenameRegex = /filename\*=UTF-8''(.+?[^;\n]*)/;
        var matches = filenameRegex.exec(customHeader);
        if (matches !== null && matches[1]) {
          fileName = matches[1];
        }
      }

      return decodeURIComponent(fileName);
    }

    function getContentType(xhr) {
      var contentTypeHeader = xhr.getResponseHeader("Content-Type");
      return contentTypeHeader.replace(" ", "");
    }

    function sendChangePasswordInvitation(email) {
      $.ajax({
        url: `/Clients/SendChangePasswordInvitation/${email}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    }

    function sendBlockRequest(id) {
      $.ajax({
        url: `/Clients/Block/${id}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    }

    function sendUnblockRequest(id) {
      $.ajax({
        url: `/Clients/Unblock/${id}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    }

    function sendLoginAsClientAccountOwnerRequest(id) {
      $.ajax({
        url: `/Clients/LoginAsClientAccountOwner/${id}`,
        method: "POST",
        contentType: "application/json",
      }).done(function (data) {
        window.open(data);
      });
    }
  };

  return {
    init: init,
  };
})();
